import { formTypes } from './types';
import { FORM_FIELDS, FORMS_TYPE_MAP } from './consts';

export const getFormBlocks = (type: formTypes) => {
  // @ts-ignore
  const model = FORMS_TYPE_MAP[type];
  if (!model) return [];
  return [...model];
};

export const fillFormData = (data: any, context: formTypes, setValue: any) => {
  setValue(FORM_FIELDS.BUSINESS_NAME, data?.name);
  setValue(FORM_FIELDS.EMAIL, data?.email);
  setValue(FORM_FIELDS.ACH_ACCOUNT_NUMBER, data?.achAccountData?.accountNumber);
  setValue(FORM_FIELDS.ACH_ROUTING_NUMBER, data?.achAccountData?.routingNumber);
  setValue(FORM_FIELDS.WIRE_ACCOUNT_NUMBER, data?.wireAccountData?.accountNumber);
  setValue(FORM_FIELDS.WIRE_ROUTING_NUMBER, data?.wireAccountData?.routingNumber);
  setValue(FORM_FIELDS.LINE_ONE, data?.supplierAddressData?.line1);
  setValue(FORM_FIELDS.LINE_TWO, data?.supplierAddressData?.line2);
  setValue(FORM_FIELDS.ZIP_CODE, data?.supplierAddressData?.postalCode);
  setValue(FORM_FIELDS.CITY, data?.supplierAddressData?.city);
  setValue(FORM_FIELDS.STATE, data?.supplierAddressData?.state);
  setValue(FORM_FIELDS.FIRST_NAME, data?.firstName);
  setValue(FORM_FIELDS.LAST_NAME, data?.lastName);
  setValue(FORM_FIELDS.PHONE, data?.phone);
  setValue(FORM_FIELDS.NOTIFY_ON_PAYMENT, data?.notifyOnPayment);
};
